import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { LocalSettingsService } from "~app/core/storage";
import { FirebaseAuthService } from "../firebase/firebase-auth.service";
import { OidcClientAuthService } from "./oidc-client-auth.service";

@Component({
    selector: "odq-signout-redirect-callback",
    template: `<div></div>`,
    standalone: false
})
export class SignoutRedirectCallbackComponent implements OnInit {
  constructor(
    private oidcAuthService: OidcClientAuthService,
    private firebaseAuthService: FirebaseAuthService,
    private localSettingsService: LocalSettingsService,
    private router: Router
  ) {}

  ngOnInit() {
    this.oidcAuthService.completeLogout().then((user) => {
      console.log("OidcAuthService complete logout");
      this.localSettingsService.clearBrowserData();
      this.firebaseAuthService.signOut();
      this.router.navigate(["/"], { replaceUrl: true });
    });
  }
}
